import { useState, useEffect, useCallback } from 'react';

import {
  LG,
  LG_MAX_WIDTH,
  LG_MIN_WIDTH,
  MD,
  MD_MAX_WIDTH,
  MD_MIN_WIDTH,
  SM,
  SM_MAX_WIDTH,
  SM_MIN_WIDTH,
  XL,
  XL_MIN_WIDTH,
  XS,
  XS_MIN_WIDTH
} from '../constants/screenSizeConst';

export default function useWindowDimensions() {
  const hasWindow = typeof window !== 'undefined';

  const getWindowDimensions = useCallback(() => {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;

    const screenSize = {
      screenXS: width < XS_MIN_WIDTH,
      screenSM: SM_MIN_WIDTH <= width && width < SM_MAX_WIDTH,
      screenMD: MD_MIN_WIDTH <= width && width < MD_MAX_WIDTH,
      screenLG: LG_MIN_WIDTH <= width && width < LG_MAX_WIDTH,
      screenXL: width > XL_MIN_WIDTH
    };
    const isMobileScreen = screenSize.screenXS || screenSize.screenSM;
    const isTabletScreen = screenSize.screenMD;
    const isDeskScreen = screenSize.screenLG || screenSize.screenXL;

    const sizeTypeMap = {
      screenXS: XS,
      screenSM: SM,
      screenMD: MD,
      screenLG: LG,
      screenXL: XL
    };
    const screenSizeType = Object.entries(sizeTypeMap).find(([key]) => screenSize[key])?.[1] || 'Unknown';

    return {
      width,
      height,
      isMobileScreen,
      isTabletScreen,
      isDeskScreen,
      screenSizeType,
      ...screenSize
    };
  }, [hasWindow]);

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const handleResize = useCallback(() => {
    setWindowDimensions(getWindowDimensions());
  }, [getWindowDimensions]);

  useEffect(() => {
    if (hasWindow) {
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [hasWindow, handleResize]);

  return windowDimensions;
}
